import ReactHtmlParser from 'react-html-parser';
import { sanitize } from 'dompurify';

const SanitizedReactHtmlParser = (content) => ReactHtmlParser(sanitize(content, {
  ADD_TAGS: ['iframe'], // or ALLOWED_TAGS
  ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'], // or //or ALLOWED_ATR
}));

export default SanitizedReactHtmlParser;
